module.exports = new __parcel__URL__("status-default-story-points.ddaf8c4a.svg").toString();